var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-button', { attrs: { "type": "danger", "icon": "el-icon-delete", "plain": "", "circle": "" }, on: { "click": _vm.handleClickDeleteButton } });
};
var staticRenderFns = [];

export { render, staticRenderFns };